import PerfectScrollbar from "perfect-scrollbar";
require("perfect-scrollbar/css/perfect-scrollbar.css");

export default class FkPerfectScroll{
    constructor($main,autoHide=true){
        //PerfectScrollbar
        //https://github.com/utatti/perfect-scrollbar
        let scrollableDom=$main.get(0);
        new PerfectScrollbar(scrollableDom,
            {
                wheelSpeed: 1,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollX:true,
                swipeEasing:true
            }
        );
        let $header=$("header");


        scrollableDom.addEventListener("ps-scroll-y",function(){
            STAGE.emit(EVENTS.SCROLL);
        });
        //see header.less
        scrollableDom.addEventListener("ps-scroll-up",function(){
            $header.removeClass("scroll-down")
        });
        scrollableDom.addEventListener("ps-scroll-down",function(e){
            $header.addClass("scroll-down")
        });

        if(autoHide){
            let $ps=$(".ps__thumb-y");
            //affiche le scroll, puis le masque au bout de 3 secondes
            function psShowHide(){
                TweenMax.killTweensOf($ps);
                TweenMax.to($ps,0.2,{x:0,onComplete:function(){
                        TweenMax.to($ps,0.2,{x:20,delay:3});
                }});
            }
            //affiche le scroll qd on bouge
            $main.on("mousemove mousewheel ps-scroll-y ps-scroll-x",function(){
                psShowHide();
            });


        }
    }
}


// WEBPACK FOOTER //
// ./fk.app/_src/scroll-stuff/FkPerfectScroll.js